// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"4f71968d","122":"4f71968d","131":"4f71968d","228":"4f71968d","496":"4f71968d","537":"4f71968d","547":"2583431d","598":"4f71968d","636":"4f71968d"}[chunkId] + ".chunk.css";
};